export const crvLimitIdentifierTypeValues = ['ca_id', 'license_plate'] as const;
export type CrvLimitIdentifierType = (typeof crvLimitIdentifierTypeValues)[number];

export const crvLimitModeValues = ['production', 'training'] as const;
export type CrvLimitMode = (typeof crvLimitModeValues)[number];

export interface CrvLimitLedgerEntryDto {
  id: string;
  companyId: string;
  storeId: string;
  locationId: string;
  stationId: string;
  operatorUserId: string;
  materialId: string;
  identifierType: CrvLimitIdentifierType;
  identifierValue: string;
  occurredAt: string; // ISO datetime
  mode: CrvLimitMode;
  totalCrvPaid: number;
  swRatePerLb: number;
  equivalentLbs: number;
  isReversal: boolean;
  reversalOfEntryId: string | null;
  purchaseId: string | null;
  createdAt: string; // ISO datetime
}

export interface CreateCrvLimitLedgerEntryRequest {
  companyId: string;
  storeId: string;
  locationId: string;
  stationId: string;
  operatorUserId: string;
  materialId: string;
  identifierType: CrvLimitIdentifierType;
  identifierValue: string;
  occurredAt: string; // ISO datetime
  mode: CrvLimitMode;
  totalCrvPaid: number;
  swRatePerLb: number;
  equivalentLbs: number;
  isReversal?: boolean;
  reversalOfEntryId?: string | null;
  purchaseId?: string | null;
}

export interface CreateCrvLimitLedgerEntryResponse {
  entry: CrvLimitLedgerEntryDto;
}

export interface CrvLimitCheckRequest {
  companyId: string;
  storeId: string;
  locationId: string;
  stationId: string;
  materialId: string;
  identifierType: CrvLimitIdentifierType;
  identifierValue: string;
  occurredAt: string; // ISO datetime
  swRatePerLb: number;
  pendingCrvPaid: number;
}

export interface CrvLimitCheckResponse {
  isAllowed: boolean;
  limitLbs: number | null;
  usedEquivalentLbs: number | null;
  requestedEquivalentLbs: number | null;
  remainingEquivalentLbs: number | null;
}
